export enum WobType {
  WobIrisGdb = 'WobIrisGdb',
  WobGliderGdb = 'WobGliderGdb',
  WobGliderIrisGdb = 'WobGliderIrisGdb',
  WobGliderStatus = 'WobGliderStatus',
  WobGliderHang = 'WobGliderHang',
  WobGliderAlarm = 'WobGliderAlarm',
  WobGliderNav = 'WobGliderNav',
  WobGliderFile = 'WobGliderFile',
  WobDatapoolChanged = 'WobDatapoolChanged',
  WobGliderModConf = 'WobGliderModConf',
  WobAdminChanged = 'WobAdminChanged',
  WobLogbookChanged = 'WobLogbookChanged',
  WobGliderModEvent = 'WobGliderModEvent',
  wobGliderNmea = 'wobGliderNmea',

  WobKeepAlive = 'WobKeepAlive',
  WobServiceBroker = 'WobServiceBroker',

  WobIrisProcessingSimuprogress = 'WobIrisProcessingSimuprogress',

  WobIrisProcessingNewPicture = 'WobIrisProcessingNewPicture',
  WobIrisProcessingPathprogress = 'WobIrisProcessingPathprogress',
  WobIrisProcessingKeepFormation = 'WobIrisProcessingKeepFormation',

  WobFleetStatus = 'WobFleetStatus',

  WobAisStatus = 'WobAisStatus',
}
